import { Controller } from '@hotwired/stimulus'
import { Previewer } from 'pagedjs'

export default class PDFPreviewController extends Controller {
  static targets = ['source', 'preview']

  async connect() {
    const paged = new Previewer()
    await paged.preview(this.sourceTarget.content, [RAILS_ASSET_URL('pdf.css')], this.previewTarget)
  }
}
